// extracted by mini-css-extract-plugin
export default {"primary":"button_primary__ucIgq","button":"button_button__Ah7o+","outline":"button_outline__1rqNs"};